module.exports = __webpack_public_path__ + "static/media/logResetAxes.ab0559f7.svg";